<template>
  <div class="integracion-expediente-principal">
    <modal-pdf :urlDocumento="urlPdf"></modal-pdf>
    <titulo-seccion titulo="GENERAR INFORMACIÓN DE PAGO"></titulo-seccion>
    <div class="container form-container">
      <form>
        <!--Datos del cliente-->
        <div class="row row-cols-lg-12 w-100 mt-3">
          <div class="row col-lg-12" style="text-align: left">
            <label class="label-formulario-solicitud">
              Datos del cliente
            </label>
          </div>
          <div class="row row-cols-lg-12 w-100 mt-3">
            <div class="col-lg-4" style="text-align: left">
              <label class="label-tipo-documento float-left w-100 mb-2">
                Persona: </label
              >
               <label class="float-left w-100 mb-2">
             <strong> {{ tipoCliente }} </strong></label
              >
            </div>
            <div class="col-lg-4" style="text-align: left">
              <label class="label-tipo-documento float-left w-100 mb-2">
                Sucursal: </label
              >
                <label class="float-left w-100 mb-2">
                <strong> {{ datosEmbajador.sucursal }} </strong></label
              >
            </div>
            <div class="col-lg-4" style="text-align: left">
              <label class="label-tipo-documento float-left w-100 mb-2">
                Nombre: </label
              >
               <label class="float-left w-100 mb-2">
                <strong> {{ nombreCliente }} </strong></label
              >
            </div> 
          </div>
          
           
          <div class="row row-cols-lg-12 w-100 mt-3">
            <div class="col-lg-4" style="text-align: left">
              <label class="label-tipo-documento float-left w-100 mb-2">
                Embajador: </label
              >
               <label class="float-left w-100 mb-2">
                <strong> {{ datosEmbajador.nombre }} </strong></label
              >
            </div>
             <div class="col-lg-4" style="text-align: left">
              <label class="label-tipo-documento float-left w-100 mb-2">
                Valor de la propiedad: 
                </label
              >
               <label class="float-left w-100 mb-2">
                <strong> {{ DarFormatoMoneda(montoPropiedad) }} </strong></label
              >
            </div>
            <div class="col-lg-4" style="text-align: left">
              <label class="label-tipo-documento float-left w-100 mb-2">
                Contacto embajador: 
                </label
              >
               <label class="float-left w-100 mb-2">
                <strong> {{ datosEmbajador.correo }} </strong></label
              >
            </div>
          </div>
          
    
          <div class="row row-cols-lg-12 w-100 mt-3">
            <div class="col-lg-4" style="text-align: left">
              <label class="label-tipo-documento float-left w-100 mb-2">
                Alta: </label
              >
               <label class="float-left w-100 mb-2">
                <strong> {{ FechaAltaProspecto }} </strong></label
              >
            </div>
            <div class="col-lg-4" style="text-align: left">
              <label class="label-tipo-documento float-left w-100 mb-2">
                Preautorizacion: </label
              >
               <label class="float-left w-100 mb-2">
                <strong> {{ FechaPreautorizacion }} </strong></label
              >
            </div>
              <div class="col-lg-4" style="text-align: left">
              <label class="label-tipo-documento float-left w-100 mb-2">
                Generacion pago: 
                </label
              >
               <label class="float-left w-100 mb-2">
                <strong> {{ FechaGeneracionPago }} </strong></label
              >
            </div>
          </div>
           <div class="row row-cols-lg-12 w-100 mt-3">          
            <div class="col-lg-4" style="text-align: left">
              <label class="label-tipo-documento float-left w-100 mb-2"
                >Tipo de inmueble: </label
              >
                <label class="float-left w-100 mb-2"
                ><strong> {{ TipoInmueble }} </strong></label
              >
            </div>
                <div class="col-lg-4" style="text-align: left">
              <label class="label-tipo-documento float-left w-100 mb-2">
                Uso del inmueble: </label
              >
               <label class="float-left w-100 mb-2">
                <strong> {{ UsoInmueble }} </strong></label
              >
            </div>
            <div class="col-lg-4" style="text-align: left">
              <label class="label-tipo-documento float-left w-100 mb-2">
                Tipo de ubicación: </label
              >
                <label class="float-left w-100 mb-2">
                <strong> {{ TipoUbicacion }} </strong></label
              >
            </div>
          </div>
          <div class="row row-cols-lg-12 w-100 mt-3">    
               <div class="col-lg-4" style="text-align: left">
              <label class="label-tipo-documento float-left w-100 mb-2">
                Estado inmueble: </label
              >
                <label class="float-left w-100 mb-2">
                <strong> {{ Estado }} </strong></label
              >
            </div>
          </div>
        </div>
        <!--Fin Datos del cliente-->
    <div class="row col-lg-12">
      <hr class="divisor-seccion" />
    </div>
        <div class="row row-cols-lg-12 w-100 mt-3">
           <label class="label-formulario-solicitud">
             Plan:
            </label>
          <div class="col-12">
            <DropDown
              :placeholder="'Selecciona una originación'"
              :arreglo="this.planes"
              llave="planId"
              valor="planId"
              texto="nombre"
              v-model="PlanId"
            ></DropDown>
            <!--<input
              type="text"
              class="form-control campo-basico"
              v-model="textoPlan"
              required
            />-->
          </div>
        </div>
        <div class="row row-cols-lg-12 w-100 mt-3">
           <label class="label-formulario-solicitud">
             Monto contratado:
            </label>
          <div class="col-12" v-if="Plan != null">
            <VueAutonumeric
              v-model.lazy="Calculador.montoContratado"
              class="form-control campo-basico"
              :options="{
                digitGroupSeparator: ',',
                decimalCharacter: '.',
                decimalCharacterAlternative: '.',
                currencySymbol: '$',
                currencySymbolPlacement: 'p',
                roundingMethod: 'U',
                minimumValue: '0',
                maximumValue: this.Calculador.planMontoMaximo
              }"
              :placeholder="'Ej. $ 250,000.00'"
              required
            ></VueAutonumeric>
          </div>
          <div class="col-12" v-else>
            <VueAutonumeric
              disabled
              v-model.lazy="Calculador.montoContratado"
              class="form-control campo-basico"
              :options="{
                digitGroupSeparator: ',',
                decimalCharacter: '.',
                decimalCharacterAlternative: '.',
                currencySymbol: '$',
                currencySymbolPlacement: 'p',
                roundingMethod: 'U',
                minimumValue: '0',
                maximumValue: this.Calculador.planMontoMaximo
              }"
              :placeholder="'Ej. $ 250,000.00'"
            ></VueAutonumeric>
          </div>
        </div>
        <div class="row row-cols-lg-12 w-100 mt-4" style="text-align: center;">
          <label class="label-formulario-solicitud seccion-pago">
            Integración de la cuota de inscripción</label
          >
        </div>
        <div class="row row-cols-lg-12 w-100 mt-2">
          <div
            class="col-lg-4 campo-pago"
            v-if="
              Calculador.montoContratado != null ||
                Calculador.montoContratado != 0
            "
            style="text-align: initial;"
          >
            <label class="label-tipo-documento">
              Descuento de cuota de inscripción:
            </label>
            <VueAutonumeric
              v-model="Calculador.porcentajeDescuentoInscripcion"
              class="form-control campo-basico"
              :options="{
                suffixText: '%',
                decimalPlaces: '4',
                minimumValue: '0',
                maximumValue: '100'
              }"
              :placeholder="'Ej. 20%'"
            ></VueAutonumeric>
          </div>
          <div class="col-lg-4 campo-pago" v-else style="text-align: initial;">
            <VueAutonumeric
              disabled
              v-model="Calculador.porcentajeDescuentoInscripcion"
              class="form-control campo-basico"
              :options="{
                suffixText: '%',
                decimalPlaces: '4',
                minimumValue: '0',
                maximumValue: '100'
              }"
              :placeholder="'Ej. 20%'"
            ></VueAutonumeric>
          </div>
          <div class="col-lg-4 campo-pago" style="text-align: initial;">
            <label class="label-tipo-documento">Cuota de inscripción:</label>
            <VueAutonumeric
              v-model="Calculador.cuotaInscripcion"
              disabled
              class="form-control campo-basico"
              :options="{
                digitGroupSeparator: ',',
                decimalCharacter: '.',
                decimalPlaces: '2',
                decimalCharacterAlternative: '.',
                currencySymbol: '$',
                currencySymbolPlacement: 'p',
                roundingMethod: 'U',
                minimumValue: '0',
                maximumValue: '500000'
              }"
              :placeholder="'$ 0.00'"
            ></VueAutonumeric>
          </div>
          <div class="col-lg-4 campo-pago" style="text-align: initial;">
            <label class="label-tipo-documento"
              >IVA cuota de inscripción:</label
            >
            <VueAutonumeric
              disabled
              v-model="Calculador.montoIVACuotaInscripcion"
              class="form-control campo-basico"
              :options="{
                digitGroupSeparator: ',',
                decimalCharacter: '.',
                decimalCharacterAlternative: '.',
                decimalPlaces: '1',
                currencySymbol: '$',
                decimalPlaces: '1',
                roundingMethod: 'U',
                minimumValue: '0',
                maximumValue: '500000'
              }"
              :placeholder="'$ 0.00'"
            ></VueAutonumeric>
          </div>
        </div>
        <div class="row row-cols-lg-12 w-100 mt-4" style="text-align: center;">
          <label class="label-formulario-solicitud"> Monto a pagar</label>
        </div>
        <div class="row row-cols-lg-12 w-100 mt-2">
          <div class="col-lg-4" style="text-align: initial;">
            <label class="label-tipo-documento">
              Tarjeta de Débito 0% com.(pago único)<br/>
            </label>
            <VueAutonumeric
              disabled
              v-model="Calculador.montoPagarTarjetaUnaEx"
              :placeholder="'$ 0.00'"
              class="form-control campo-basico"
              :options="'dollar'"
            ></VueAutonumeric>
          </div>
          <div class="col-lg-4 campo-pago" style="text-align: initial;">
            <label class="label-tipo-documento">
              Tarjeta de Crédito 6% com.(3 MSI)<br/>
            </label>
            <VueAutonumeric
              disabled
              v-model="Calculador.montoPagarTarjetTresMeses"
              :placeholder="'$ 0.00'"
              class="form-control campo-basico"
              :options="'dollar'"
            ></VueAutonumeric>
          </div>
          <div class="col-lg-4 campo-pago" style="text-align: initial;">
            <label class="label-tipo-documento">
              Pago en Ventanilla o Transferencia Electrónica
              <!-- Pago directo en ventanilla / Transferencia electrónica: -->
            </label>
            <VueAutonumeric
              disabled
              v-model="Calculador.montoPagarTransferencia"
              :placeholder="'$ 0.00'"
              class="form-control campo-basico"
              :options="'dollar'"
            ></VueAutonumeric>
          </div>
          <div class="row row-cols-lg-12 w-100 mt-2">
          <div class="col-lg-4" style="text-align: initial;">
            <label class="label-tipo-documento">
              Tarjeta de Crédito 2% com.(pago único)<br/>
            </label>
            <VueAutonumeric
              disabled
              v-model="Calculador.montoPagarCreditoUnaEx"
              :placeholder="'$ 0.00'"
              class="form-control campo-basico"
              :options="'dollar'"
            ></VueAutonumeric>
          </div>
          <div class="col-lg-4" style="text-align: initial;">
            <label class="label-tipo-documento">
              Tarjeta Internacional 3% com.(Crédito/Débito)<br/>
            </label>
            <VueAutonumeric
              disabled
              v-model="Calculador.montoPagarTarjetaInternacional"
              :placeholder="'USD$ 0.00'"
              class="form-control campo-basico"
              :options="'dollar'"
            ></VueAutonumeric>
          </div>
        </div>
        </div>
        <div class="row row-cols-lg-12 w-100 mt-4" style="text-align: center">
          <label class="label-formulario-solicitud"
            >Remanentes - Adjudicación inmediata</label
          >
        </div>
        <div class="row row-cols-lg-12 w-100 mt-3">
          <div class="row">
            <div class="col-8 campo-pago" style="text-align: initial">
               <label class="label-tipo-documento"
                >¿Acepto participar en los remanentes del grupo?</label
              >
            </div>
            <div class="col">
              <span
                class="opcion-checkbox"
                v-for="opcion in catalogos.remanentes"
                v-bind:key="opcion.value"
              >
                <input
                  type="radio"
                  class="form-check-input"
                  :value="opcion.value"
                  v-model="ActualizacionInformacionPago.participaEnRemanentes"
                  required
                />
                <label class="etiqueta-checkbox">
                  {{ opcion.text }}
                </label>
              </span>
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-12 w-100 mt-3">
          <div class="row">
            <div class="col-8 campo-pago" style="text-align: initial">
               <label class="label-tipo-documento"
                >Expectativa de adjudicación inmediata</label
              >
            </div>
            <div class="col">
              <span
                class="opcion-checkbox"
                v-for="opcion in catalogos.adjudicacion"
                v-bind:key="opcion.value"
              >
                <input
                  type="radio"
                  class="form-check-input"
                  :value="opcion.value"
                  v-model="ActualizacionInformacionPago.adjudicacionInmediata"
                  required
                />
                <label class="etiqueta-checkbox">
                  {{ opcion.text }}
                </label>
              </span>
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-12 w-100 mt-4">
          <div class="col-6">
            <label class="label-formulario-solicitud mb-2"
              >Originación de venta</label
            >
            <DropDown
              :placeholder="'Selecciona una originación'"
              :arreglo="this.catalogos.origenesVenta"
              llave="origenVentaId"
              valor="origenVentaId"
              texto="descripcion"
              v-model="ActualizacionInformacionPago.originacionVenta"
            ></DropDown>
          </div>
          <div class="col-6">
            <label class="label-formulario-solicitud mb-2"
              >Canal de venta</label
            >
            <DropDown
              :placeholder="'Selecciona un canal de venta'"
              :arreglo="this.catalogos.canalesVenta"
              llave="canalVentaId"
              valor="canalVentaId"
              texto="descripcion"
              v-model="ActualizacionInformacionPago.canalVenta"
            ></DropDown>
          </div>
        </div>
        <div class="row row-cols-lg-12 w-100 mt-4 mb-2">
          <div class="col-4">
            <label class="label-formulario-solicitud">Tipo de venta</label>
          </div>
          <div class="col-4 d-flex justify-content-between">
            <span
              class="opcion-checkbox m-0"
              v-for="opcion in catalogos.tipoVenta"
              v-bind:key="opcion.value"
            >
              <input
                type="radio"
                class="form-check-input"
                :value="opcion.value"
                v-model="ActualizacionInformacionPago.ventaTipo"
                required
              />
              <label class="etiqueta-checkbox">
                {{ opcion.text }}
              </label>
            </span>
          </div>
        </div>
            <div class="row col-lg-12">
      <hr class="divisor-seccion" />
    </div>
        <!--Seccion documentos del cliente-->
        <div class="row row-cols-lg-12 w-100 mt-3">
          <div class="row col-12 mt-2 mb-2">
            <label class="label-formulario-solicitud">
              Documentos del cliente
            </label>
          </div>
          <div class="table-responsive">
            <table class="table tabla-preautorizacion">
              <thead class="encabezado-tabla">
                <tr>
                  <th scope="col">Propietario</th>
                  <th scope="col">Documento</th>
                  <th scope="col">Archivo</th>
                  <th scope="col">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(archivo, index) in ArchivosExpedienteAuxiliar"
                  :key="archivo.archivoId"
                  class="mt-3"
                >
                <td class="text-start" style="width: 250px;">
                  {{archivo.propietario || 'Sin propietario'}}
                </td>
                  <td class="texto-tabla">
                    {{ index++ + ".- " }}
                    {{
                      archivo.tipoDocumentoStr.charAt(0).toUpperCase() +
                        archivo.tipoDocumentoStr.slice(1)
                    }}
                  </td>
                  <td class="p-8">
                    <label class="texto-tabla-obs text-left">
                      {{ archivo.nombreOriginal }}
                    </label>
                  </td>
                  <td class="tabla-preautorizacion__td-acciones p-0">
                    <i
                      v-if="archivo.extension == '.PDF'"
                      data-bs-toggle="modal"
                      data-bs-target="#modalPdf"
                      v-on:click="VerArchivo(archivo.archivoId)"
                      class="fa fa-eye iconoVer-png"
                    ></i>
                    <i
                      v-else
                      v-on:click="AvisoFormato()"
                      class="fa fa-eye iconoVer-png"
                    ></i>
                    <i
                      v-on:click="descargarArchivo(archivo.archivoId)"
                      class="fa fa-download iconoArchivo-png"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--ESTO SOLO SE MUESTRA EN MOVIL-->
          <div class="listado-documentos-movil">
            <!--DOCUMENTOS-->
            <div
              class="row col-lg-12"
              v-for="archivo in ArchivosExpediente"
              :key="archivo.archivoId"
            >
              <strong
                class="titulo-seccion documento-movil"
                style="margin-right: 10px"
              >
                {{
                  archivo.tipoDocumentoStr.charAt(0).toUpperCase() +
                    archivo.tipoDocumentoStr.slice(1) +
                    "(" +
                    archivo.documentoStr +
                    ")"
                }}
              </strong>
              <div class="row col-12" style="margin-top: -10px">
                <div class="col-10" style="text-align: initial">
                  <label class="texto-tabla-obs">
                    {{ archivo.nombreOriginal }}
                  </label>
                </div>
                <div class="col-2">
                  <i
                    v-if="archivo.extension == '.PDF'"
                    data-bs-toggle="modal"
                    data-bs-target="#modalPdf"
                    v-on:click="VerArchivo(archivo.archivoId)"
                    class="fa fa-eye iconoVer-png"
                  ></i>
                  <i
                    v-else
                    v-on:click="AvisoFormato()"
                    class="fa fa-eye iconoVer-png"
                  ></i>
                  <i
                    v-on:click="descargarArchivo(archivo.archivoId)"
                    class="fa fa-download iconoArchivo-png"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Seccion documentos del cliente-->
        <div class="row col-lg-12 d-flex justify-content-center mb-3">
          <button
            v-if="generandoInformacionPago"
            class="boton-primario"
            style="height: 50px;"
            disabled
          >
            <v-progress-circular
              indeterminate
              size="30"
              color="primary"
            ></v-progress-circular>
          </button>
          <button
            v-else
            class="boton-primario"
            style="height: 50px;"
            @click.prevent="LiberarAPago"
          >
            Liberar a pago
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

//Componentes
//Plugins
import axios from "axios";
import servicios from "../../../servicios/service.js";
//Componentes
import VueAutonumeric from "../../../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric.vue";
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import DropDown from "../components/DropDown.vue";
import ModalPdf from "../components/ModalPdf.vue";
//Mixins
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";

//Rutas API
var rutaPlanes = "/api/Master/Calculador/ListarPlanes";
var rutaIVA = "/api/Master/Calculador/ObtenerPorcentajeIva";
var rutaEnvioInformacionPago = "/api/Master/Calculador/EnviarInformacionPago";
var rutaInsertarMonto = "/api/Master/SolicitudInscripcion/ActualizarDatosInformacionPago";
var rutaCanalesVenta = "/api/Master/SolicitudInscripcion/ListarCanalesVenta";
var rutaOrigenesVenta = "/api/Master/SolicitudInscripcion/ListarOrigenesVenta";
var rutaDescargarArchivo = "/api/Master/Archivo/DescargarArchivo";
var rutaVerArchivo = "/api/Master/Archivo/VerArchivo";
var rutaCargarArchivosExpedienteProspecto =
  "/api/Master/PreAutorizacion/ObtenerArchivosExpedienteProspectoConFiguras";
const rutaObtenerMontoPropiedad =
  "/api/Master/Prospecto/ConsultarMontoPropiedad";
const rutaConsultarEmbajador =
  "/api/Master/Prospecto/ObtenerProspectoEmbajador";
// const rutaConsultarEmbajador =
//   "/api/Master/Prospecto/ObtenerProspectoEmbajador";
// const rutaConsultarProspectoRepresentante =
//   "/api/Master/Prospecto/ObtenerProspectoRepresentanteLegal";
export default {
  name: "GenerarInformacionDePago",
  mixins: [mixinSolicitudInscripcion],
  components: {
    VueAutonumeric,
    TituloSeccion,
    DropDown,
    ModalPdf
  },
  async mounted() {
    this.ProspectoId = this.$store.getters.prospectoId;
    this.tipoPersona = await this.ObtenerTipoPersona(this.ProspectoId);
    this.tipoUsuario = this.$store.getters.tipoUsuario;
    this.usuarioId = this.$store.getters.usuarioId;
    this.ActualizacionInformacionPago.prospectoId = this.$store.getters.prospectoId;
    this.CargarPlanes();
    this.ObtenerPorcentajeIva();
    this.CargarCanalesVenta();
    this.CargarOrigenesVenta();
    this.cargarArchivosExpedienteProspecto();

    let datos = (await this.ObtenerDatosProspecto(this.ProspectoId)).data.data;
    this.etapaProspecto = datos.etapaId;
    this.TipoInmueble = datos.tipoInmuebleNombre;
    this.UsoInmueble = datos.usoInmuebleNombre;
    this.TipoUbicacion = datos.tipoUbicacionNombre;
    this.Estado = datos.estadoNombre;
    this.FechaAltaProspecto = datos.fechaCreacion;

    this.ConsultarMontoPropiedad();
    
    this.FechaPreautorizacion = (await this.ObtenerTransicionProspecto(this.ProspectoId, 5)).data.data;
    this.FechaGeneracionPago = (await this.ObtenerTransicionProspecto(this.ProspectoId, 7)).data.data;

      this.tipoCliente =
      this.tipoPersona == 0
        ? "TITULAR NACIONAL."
        : this.tipoPersona == 1
        ? "TITULAR MORAL."
        : this.tipoPersona == 2
        ? "TITULAR EXTRANJERO."
        : this.tipoPersona == 3
        ? "REPRESENTANTE LEGAL"
        : this.tipoPersona == 4
        ? "COTITULAR"
        : this.tipoPersona == 5
        ? "CO-OWNER"
        : this.tipoPersona == 6
        ? "OBLIGADO SOLIDARIO"
        : "JOINT LIABILITY";
    this.nombreCliente =
      this.tipoPersona == 1
        ? datos.nombres +
          " - " +
          datos.apellidoPaterno +
          " " +
          datos.apellidoMaterno
        : (this.tipoPersona == 2 || this.tipoPersona == 5 || this.tipoPersona == 7)
        ? datos.nombres +
          " " +
          datos.apellidoMaterno +
          " " +
          datos.apellidoPaterno
        : datos.nombres +
          " " +
          datos.apellidoPaterno +
          " " +
          datos.apellidoMaterno;

    await this.ObtenerDatosEmbajador(this.ProspectoId);
  },
  data() {
    return {
      tipoCliente: null,
      nombreCliente: null,
      etapaProspecto: null,
      FechaAltaProspecto: "Sin Fecha",
      FechaPreautorizacion: "Sin Fecha",
      FechaGeneracionPago: "Sin Fecha",
      TipoInmueble: "",
      UsoInmueble: "",
      TipoUbicacion: "",
      Estado: "",
      tipoPersona: 0,
      tipoUsuario: null,
      ProspectoId: null,
      datosEmbajador: {
        nombre: null,
        correo: null,
        telefono: null,
        sucursal: null,
        gerencia: null,
        perfil: null
      },
      planes: [],
      Plan: null,
      PlanId: null,
      textoPlan: null,
      montoPropiedad: null,
      Calculador: {
        montoContratado: null,
        cuotaInscripcion: null,
        porcentajeCuotaInscripcion: null,
        porcentajeDescuentoInscripcion: 0,
        montoIVACuotaInscripcion: null,
        porcentajeIVA: null,
        //comisiones
        comisionTPVUnaEx: 0,
        comisionTPVTresMeses: 6.0,
        planMontoMaximo: 0,
        planMontoMinimo: 250000,
        montoPagarTarjetaUnaEx: null,
        montoPagarTarjetTresMeses: null,
        montoPagarTransferencia: null,
        montoPagarTarjetaInternacional: null,
        comisionTPVInternacional: 3.0,
        comisionTPVCreditoUnaEx: 2.0,
        montoPagarCreditoUnaEx: null,
        tipoCambioUSD: null
      },
      generandoInformacionPago: false,
      catalogos: {
        remanentes: [
          { text: "Si", value: true },
          { text: "No", value: false },
        ],
        adjudicacion: [
          { text: "Si", value: true },
          { text: "No", value: false },
        ],
        tipoVenta: [
          { text: "Tradicional", value: false },
          { text: "Preventa", value: true }
        ],
        // NORMAL = 0,
        // PENDIENTE = 1,
        // FORÁNEA = 2
        canalesVenta: [],
        origenesVenta: []
      },
      ActualizacionInformacionPago: {
        prospectoId: null,
        monto: null,
        planId: null,
        porcentajeDescuentoCuotaInscripcion: null,
        montoIVACuotaInscripcion: null,
        montoCuotaInscripcionTransferencia: null,
        montoCuotaInscripcionTarjetaUnExhibicion: null,
        montoCuotaInscripcionTarjetaMeses: null,
        montoTarjetaInternacional: null,
        montoTarjetaCreditoUnaExhibicion: null,
        participaEnRemanentes: false,
        adjudicacionInmediata: false,
        originacionVenta: null,
        canalVenta: null,
        ventaTipo: null
      },
      ArchivosExpediente: [],
      ArchivosExpedienteAuxiliar: [],
      desactivarInputArchivo: false,
      urlPdf: null
    };
  },
  watch: {
    "Plan": function() {
      console.log("Plan:"+this.PlanId);
      if (this.Plan != null) {
        this.Calculador.planMontoMaximo = this.Plan.montoMaximoGrupoCliente;
        this.Calculador.planMontoMinimo = this.Plan.montoMinimo;
        this.Calculador.porcentajeCuotaInscripcion = this.Plan.porcentajeCuotaInscripcion;
      }
    },
     "PlanId": function() {
     
      if (this.PlanId != null || this.PlanId != 0) {
        console.log("CalculadorNuev:"+this.PlanId);
      this.Calculador.montoContratado = 0;
     
       this.Plan = this.planes.find(
        p => p.planId == this.PlanId
      );
      }
    },
    "Calculador.montoContratado": function() {
      this.CalcularCuotaInscripcion();
      this.CalcularIVACuotaInscripcion();
      this.CalcularMontos();
    },
    "Calculador.porcentajeDescuentoInscripcion": function() {
      if (
        this.Calculador.montoContratado < this.Calculador.planMontoMinimo ||
        this.Calculador.montoContratado == null
      ) {
        this.AlertaEmbajadores(
          "El monto minimo del monto contratado debe de ser de " +
            "$" +
            this.Calculador.planMontoMinimo,
          false
        );
        this.Calculador.montoContratado = this.Calculador.planMontoMinimo;
      } else {
        this.CalcularCuotaInscripcion();
        this.CalcularIVACuotaInscripcion();
        this.CalcularMontos();
      }
    }
  },
  methods: {
    CalcularIVACuotaInscripcion() {
      this.Calculador.montoIVACuotaInscripcion =
        this.Calculador.cuotaInscripcion * this.Calculador.porcentajeIVA;
      this.ActualizacionInformacionPago.montoIVACuotaInscripcion =
        this.Calculador.montoIVACuotaInscripcion;
    },
    CalcularCuotaInscripcion() {
      let descuento = this.Calculador.porcentajeDescuentoInscripcion / 100;
      this.Calculador.cuotaInscripcion =
        this.Calculador.montoContratado *
        this.Calculador.porcentajeCuotaInscripcion *
        (1 - descuento);
    },
    CalcularMontos() {
      //Obtener el monto de la cuota de inscripción considerando el IVA
      let cuotaInscripcion =
        this.Calculador.cuotaInscripcion +
        this.Calculador.montoIVACuotaInscripcion;
      //El monto de la cuota de inscripción en transferencia es el mismo que el monto de la cuota de inscripción
      this.Calculador.montoPagarTransferencia = cuotaInscripcion;
      //Calcular la cuota de inscripción en tarjeta de débito en una sola exhibición.
      this.Calculador.montoPagarTarjetaUnaEx =
        cuotaInscripcion +
        (cuotaInscripcion * this.Calculador.comisionTPVUnaEx) / 100;
      //Calcular la cuota de inscripción en tarjeta de crédito en una sola exhibición.
      this.Calculador.montoPagarCreditoUnaEx =
        cuotaInscripcion +
        (cuotaInscripcion * this.Calculador.comisionTPVCreditoUnaEx) / 100;
      //Calcular la cuota de inscripción en tarjeta de crédito a 3 meses.
      this.Calculador.montoPagarTarjetTresMeses =
        cuotaInscripcion +
        (cuotaInscripcion * this.Calculador.comisionTPVTresMeses) / 100;
      //Calcular la cuota de inscripción en tarjeta internacional.
      this.Calculador.montoPagarTarjetaInternacional =
        cuotaInscripcion +
        (cuotaInscripcion * this.Calculador.comisionTPVInternacional) / 100;

    },
     ConsultarMontoPropiedad() {
      const parametroProspectoId = {
        params: {
          prospectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaObtenerMontoPropiedad, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.montoPropiedad = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
     async ObtenerDatosEmbajador() {
      const prospecto = {
        params: {
          ProspectoId: this.ProspectoId
        },
      };
      axios
        .get(rutaConsultarEmbajador, prospecto)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.datosEmbajador = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    CargarPlanes() {
      axios
        .get(rutaPlanes)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.planes = resp.data.data;
            // this.Plan = this.planes[0];
            // this.textoPlan = this.planes[0].nombre;
            // this.Plan = this.planes[3];
            // this.textoPlan = this.planes[3].nombre;
          } 
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarOrigenesVenta() {
      await axios
        .get(rutaOrigenesVenta)
        .then(response => {
          if (response.data.estado === 0) {
            let origenesVenta = response.data.data;
            this.catalogos.origenesVenta = origenesVenta.sort(function(a, b) {
              if (a.descripcion < b.descripcion) {
                return -1;
              }
              if (a.descripcion > b.descripcion) {
                return 1;
              }
              return 0;
            });
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarCanalesVenta() {
      await axios
        .get(rutaCanalesVenta)
        .then(response => {
          if (response.data.estado === 0) {
            let canalesVenta = response.data.data;
            this.catalogos.canalesVenta = canalesVenta.sort(function(a, b) {
              if (a.descripcion < b.descripcion) {
                return -1;
              }
              if (a.descripcion > b.descripcion) {
                return 1;
              }
              return 0;
            });
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    ObtenerPorcentajeIva() {
      axios
        .get(rutaIVA)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.Calculador.porcentajeIVA = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, false);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    DarFormatoMoneda(monto) {
      return servicios.DarFormatoMoneda(monto);
    },
    LiberarAPago() {
      if (
        this.Calculador.montoContratado == 0 ||
        this.Calculador.montoContratado == null
      )
      {
        this.AlertaEmbajadores("Por favor, ingresa un monto contratado.", true);
        }
      else if (
        this.Calculador.montoContratado < this.Calculador.planMontoMinimo
      )
      {
        this.AlertaEmbajadores(
          "El monto mínimo debe ser de $" + this.Calculador.planMontoMinimo,
          true
        );
      }
      else if(this.ActualizacionInformacionPago.participaEnRemanentes == null)
      {
      this.AlertaEmbajadores(
          "Debe elegir la participación en remanentes.",
          true
        );
      }
      else if(this.ActualizacionInformacionPago.adjudicacionInmediata == null)
      {
      this.AlertaEmbajadores(
          "Debe elegir la adjudicación inmediata.",
          true
        );
      }
      else if(this.ActualizacionInformacionPago.originacionVenta == null || this.ActualizacionInformacionPago.originacionVenta <= 0)
      {
      this.AlertaEmbajadores(
          "Debe elegir la originación de venta.",
          true
        );
      }
      else if(this.ActualizacionInformacionPago.canalVenta == null || this.ActualizacionInformacionPago.canalVenta <= 0)
      {
      this.AlertaEmbajadores(
          "Debe elegir el canal de venta.",
          true
        );
      }
      else if(this.ActualizacionInformacionPago.ventaTipo == null)
      {
      this.AlertaEmbajadores(
          "Debe elegir el tipo de venta.",
          true
        );
      }
      else {
        this.$fire({
          title: "¿Deseas enviar la información de pago?",
          text: "Asegúrate de que la información sea correcta.",
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar"
        }).then(result => {
          if (result.value) {
            //Si da click en confirmar
            this.InsertarMonto();
          }
        });
      }
    },
    EnviarCorreo() {
      axios
        .post(rutaEnvioInformacionPago + "?prospectoId=" + this.ProspectoId)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.generandoInformacionPago = false;
            this.AlertaEmbajadores(
              "La información de pago ha sido generada y se enviará al prospecto.",
              true
            );
            this.$router.push({
              name: "AdministracionDeProspectos"
            });
          } else if (resp.data.estado === 1) {
            this.generandoInformacionPago = false;
          }
        })
        .catch(e => {
          this.generandoInformacionPago = false;
          this.ManejarExcepcion(e);
        });
    },
    InsertarMonto() {
      this.generandoInformacionPago = true;
      //Se prepara el modelo.
      this.ActualizacionInformacionPago.monto = this.Calculador.montoContratado;
      this.ActualizacionInformacionPago.planId = this.Plan.planId;
      this.ActualizacionInformacionPago.porcentajeDescuentoCuotaInscripcion = this.Calculador.porcentajeDescuentoInscripcion;
      this.ActualizacionInformacionPago.montoCuotaInscripcionTransferencia = this.Calculador.montoPagarTransferencia;
      this.ActualizacionInformacionPago.montoCuotaInscripcionTarjetaUnExhibicion = this.Calculador.montoPagarTarjetaUnaEx;
      this.ActualizacionInformacionPago.montoCuotaInscripcionTarjetaMeses = this.Calculador.montoPagarTarjetTresMeses;
      this.ActualizacionInformacionPago.montoTarjetaInternacional = this.Calculador.montoPagarTarjetaInternacional;
      this.ActualizacionInformacionPago.montoTarjetaCreditoUnaExhibicion = this.Calculador.montoPagarCreditoUnaEx;
      this.ActualizacionInformacionPago.montoIVACuotaInscripcion = this.Calculador.montoIVACuotaInscripcion;

      axios
        .post(rutaInsertarMonto, this.ActualizacionInformacionPago)
        .then(resp => {
          if (resp.data.estado === 0) {
            if (this.Calculador.porcentajeDescuentoInscripcion == 100) {
              this.generandoInformacionPago = false;
              this.AlertaEmbajadores(
                "Se generó el pago con descuento del 100% y el prospecto ha sido enviado a validación de hoja de prueba.",
                true
              );
              this.$router.push({
                name: "AdministracionDeProspectos"
              });
            } else {
              this.EnviarCorreo();
            }
          } else if (resp.data.estado === 1) {
            this.generandoInformacionPago = false;
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch(e => {
          this.generandoInformacionPago = false;
          this.ManejarExcepcion(e);
        });
    },
    //Archivos
    cargarArchivosExpedienteProspecto() {
      this.ArchivosExpedienteAuxiliar = [];
      const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId
        }
      };
      axios
        .get(rutaCargarArchivosExpedienteProspecto, parametroProspectoId)
        .then(resp => {
          if (resp.data.estado === 0) {
            let arregloArchivos = resp.data.data;
            this.ArchivosExpediente = arregloArchivos;
            for (var a of arregloArchivos) {
              let aux = {
                archivoId: a.archivoId,
                nombreOriginal: a.nombreOriginal,
                documento: a.documento,
                tipoDocumentoStr: a.tipoDocumentoStr,
                esAprobado: a.esAprobado,
                archivo: null,
                extension: a.extension,
                propietario : a.propietario
              };
              this.ArchivosExpedienteAuxiliar.push(aux);
            }
            //this.ArchivosExpediente = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    ActivaInputArchivo(index) {
      this.$refs.inputArchivo[index].click();
    },
    almacenarArchivo(event, index) {
      this.ArchivosExpedienteAuxiliar[index].archivo = event.target.files[0];
      this.subirArchivo(index);
    },
    descargarArchivo(archivoId) {
      window.location.href = rutaDescargarArchivo + "?archivoId=" + archivoId;
    },
    VerArchivo(archivoId) {
      this.urlPdf =
        window.location.origin + rutaVerArchivo + "?archivoId=" + archivoId;
    },
    AvisoFormato() {
      this.AlertaEmbajadores(
        "No se puede abrir este formato de archivo. Por favor, descárgalo para visualizarlo.",
        true
      );
    },
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";

.integracion-expediente-principal {
  flex-grow: 1;
}

.container-calculador {
  width: 75%;
}
@media (max-width: 512px) {
  .container-calculador {
    width: 100%;
  }
}

.etiqueta-formulario {
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  line-height: 30px;
  display: flex;
  color: #b38d51;
}
.etiqueta-calculador {
  background-color: #b8725a;
  padding: 10px;
  width: 100%;
  border-radius: 35px;
  color: white;
  font-family: "Poppins";
}
</style>
}
